(ns minorodata.file-ingest.model
  (:require [mold.core :as m :include-macros true]))

(declare ->ingest-step ->ingest-error ->ingest-file ->ingest-preview-data ->ingest-result ->ingest-selected-sheet ->ingest-tables)

(def wizard-steps
  [{:step       :upload-file
    :title      "Upload file"
    :page-title "Upload a file"}
   {:step       :select-sheet
    :title      "Select sheet"
    :page-title "Please select the sheet that you want to be saved"}
   {:step       :preview-data
    :title      "Preview data"
    :page-title "Please choose the header row if it exists"}
   {:step       :table-select
    :title      "Select table"
    :page-title "Specify the destination table"}
   {:step       :column-select
    :title      "Verify columns"
    :page-title "Review data import"}
   {:step       :confirmation
    :title      "Confirmation"
    :page-title "Importing your data"}])


(m/defmodel ingest-step
  {:step       [::m/keyword "Step identifier"]
   :page-title [::m/string "Human friendly page title"]}
  {:singleton true})


(m/defmodel ingest-file
  {:sheet-names {::m/type        ::m/string
                 ::m/cardinality ::m/many
                 ::m/doc         "Sheet names"}
   :bucket      [::m/string "S3 bucket name"]
   :path        [::m/string "S3 file path"]
   :source      ["Object representing file"]
   :file-name   [::m/string "File name"]}
  {:singleton true})


(m/defmodel ingest-error
  {:step         [::m/keyword "Wizard step"]
   :msg          [::m/string "Error message"]
   :title        [::m/string ::m/nilable "Title"]
   :show-loader? [::m/bool "Display of loader"]}
  {:singleton true})


(m/defmodel ingest-preview-data
  {:data {::m/type ::m/vector
          ::m/doc  "Vector of rows to preview"}

   :preview-error?        [::m/bool "Failed to fetch preview flag"]
   :preview-error-message [::m/string "Error message"]}
  {:singleton true})


(m/defmodel ingest-tables
  {:tables {::m/cardinality ::m/many
            ::m/type        ::m/string
            ::m/doc         "Vector of table names to ingest into"}}
  {:singleton true})


(m/defmodel ingest-table-params
  {:type       {::m/req  true
                ::m/type ::m/enum
                ::m/vals #{:new :existing}
                ::m/doc  "New or existing table"}
   :table-name [::m/string "Table name"]}
  {:singleton true})


(m/defmodel ingest-header-row
  {:header-idx [::m/number ::m/nilable "Header row index"]}
  {:singleton true})


(m/defmodel ingest-selected-columns
  {:columns {::m/type ::m/vector
             ::m/doc  "Selected column names"}}
  {:singleton true})


(m/defmodel ingest-selected-sheet
  {:name [::m/string "Selected sheet name"]}
  {:singleton true})


(m/defmodel ingest-data
  {:data {::m/type ::m/vector
          ::m/doc  "All rows of file as a vector"}}
  {:singleton true})


(m/defmodel ingest-result
  {:result {::m/req   true
            ::m/typer ::m/enum
            ::m/vals  #{:success :fail}
            ::m/doc   "Ingest outcome as reported by backend"}
   :total  {::m/req  false
            ::m/type ::m/number
            ::m/doc  "Total number of rows ingested in case of :success"}
   :reason {::m/req  false
            ::m/type ::m/string
            ::m/doc  "Error message in case of :fail"}}
  {:singleton true})
